import { UserProducts } from "../../../clients/catalogue/catalogue-response-types";
import URN from "../../layout/URN";

type PreferenceValue = {
  translationKey: string;
  value: string;
};

export type PreferenceSingleChoice = {
  typename: "PreferenceSingleChoice";
  urn: URN;
  preferenceKey: string;
  preferenceValues: PreferenceValue[];
  selectedValueIndex: number;
};

export type ToggleSettingsPreference = {
  typename: "TogglePreference";
  urn: URN;
  isEnabled: boolean;
};

export type UserProductsPreference = {
  typename: "UserProductsPreference";
  urn: URN;
  productOptions: UserProducts[];
  selectedProduct: (UserProducts | null)[] | null;
};

export type ConfirmCashoutPreferenceData = {
  typename: "ConfirmCashoutPreference";
  urn: string;
  shouldConfirmCashout: boolean;
};

// This type is the union of all the preferences types
export type SettingsPreference = PreferenceSingleChoice | ToggleSettingsPreference;

export type PreferenceSingleChoicePreferences = {
  [urn: string]: PreferenceSingleChoice;
};

export type SettingsPreferences = {
  [urn: string]: SettingsPreference;
};

export type TogglePreferences = {
  [urn: string]: ToggleSettingsPreference;
};

export enum SpecialSingleChoicePreferences {
  userProducts = "products",
  defaultProduct = "defaultProduct",
  confirmCashout = "confirmCashout",
  exchangeBeaconsDisplay = "exchangeBeaconsDisplay",
}

export { PreferenceLayout } from "../../../clients/catalogue/catalogue-response-types";
